export const ERROR_MESSAGES = {
  DEFAULT: {
    LABEL: "DEFAULT_MESSAGE",
    MSG: "Ha ocurrido un error inesperado. Inténtelo nuevamente. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TAL000: {
    LABEL: "INVALID_DATE_FORMAT",
    MSG: "Formato de fecha inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TAL001: {
    LABEL: "PRECONDITION_FAILED",
    MSG: "La precondición para esta solicitud ha fallado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TAL002: {
    LABEL: "INVALID_OPERATION_NUMBER",
    MSG: "El número de operación dado no es alfanumérico. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TAL003: {
    LABEL: "INVALID_PARAMETER_VALUE",
    MSG: "El valor de alguno de los parámetros es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TAL004: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Ha ocurrido un error en el envío del correo. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TAL005: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "El ruc de agencia del usuario descrito por número de documento ingresado no es válido (dni ingresado no válido). Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TAL006: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "El número de documento ingresado no es numérico. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG000: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El servicio de autenticación cambió la forma de enviar la respuesta. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG001: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El servicio de autenticación no puede encontrar el recurso solicitado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG002: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El servicio de autenticación encontró un parámetro inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG003: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El usuario dado no está autorizado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG004: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El usuario dado ha realizado la misma petición demasiadas veces. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG005: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "Se requiere restablecer la contraseña. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG006: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El usuario dado no se encuentra. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG007: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El usuario dado no ha realizado su confirmación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG008: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El servicio de autenticación encontró un error interno. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG009: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "No se han enviado correctamente las credenciales al sistema de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG010: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Ha surgido una excepción inesperada del sistema de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG011: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Se ha configurado de manera incorrecta los permisos del usuario dado en el sistema de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG012: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "Se ha encontrado una excepción en la validación de uno de los subsistemas del servicio de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG013: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Ha surgido un problema interno en la validación de los servicios del sistema de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG014: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El servicio de autenticación no puede encontrar uno de los métodos internos de validación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG015: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Ha surgido un problema interno en la validación de los servicios del sistema de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG016: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Error interno en la configuración del servicio de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG017: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El nombre de usuario ya ha sido registrado en nuestro sistema de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  COG018: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El correo electrónico ya ha sido registrado en nuestro sistema de autenticación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },

  LAM001: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "No se ha podido crear sesión en uno de los sistemas. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  LAM002: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Ha surgido un problema inesperado al invocar uno de los servicios internos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM000: {
    LABEL: "FORBIDDEN_USER",
    MSG: "El usuario no tiene acceso para realizar esta operación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM001: {
    LABEL: "FORBIDDEN_OPERATION",
    MSG: "El usuario no tiene los permisos para realizar esta operación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM002: {
    LABEL: "ISNT_POSSIBLE_TO_UPDATE",
    MSG: "La DAM no ha podido ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM003: {
    LABEL: "CANT_BE_UPDATED",
    MSG: "La DAM no puede ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM004: {
    LABEL: "INVALID_DISPATCH_TYPE",
    MSG: "El tipo de despacho es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM005: {
    LABEL: "DOESNT_EXIST_ADUANA_ERROR",
    MSG: "La DAM indicada no pudo ser encontrada en los registros de SUNAT. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM006: {
    LABEL: "HAS_BLOCKED_LEVANTE",
    MSG: "La DAM no cuenta con levante autorizado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM007: {
    LABEL: "DELIVERY_DESTINATION_IS_NOT_TALMA",
    MSG: "El destino de entrega de esta DAM no corresponde a Talma. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM008: {
    LABEL: "USER_RUC_DOESNT_MATCH_SUNAT",
    MSG: "El RUC de la agencia del usuario no corresponde al RUC de la DAM indicada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM009: {
    LABEL: "NOT_PASS_DESPACHO_TYPE_EXCEPTIONAL",
    MSG: "La información de los bienes de la DAM no corresponde a la de los volantes. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM010: {
    LABEL: "NOT_PASS_DESPACHO_TYPE_URGENT",
    MSG: "La información de los bienes de la DAM no corresponde a la de los volantes. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM011: {
    LABEL: "NOT_PASS_DESPACHO_TYPE_ANTICIPATED",
    MSG: "La información de los bienes de la DAM no corresponde a la de los volantes. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM012: {
    LABEL: "FAILED_CHECK_VALIDATION",
    MSG: "Algún DAM relacionado a alguno de los volantes tuvo problemas con SUNAT. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  DAM014: {
    LABEL: "FAILED_CHECK_VALIDATION",
    MSG: "Hubo problemas tratando de emparejar la guía hija entre los volantes con SUNAT. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL000: {
    LABEL: "FORBIDDEN_OPERATION",
    MSG: "El usuario no tiene los permisos para realizar esta operación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL001: {
    LABEL: "THIRD_PARTY_BILLING_AUTHORIZATION_REQUIRED",
    MSG: "Este RUC Facturable requiere autorización de terceros. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL002: {
    LABEL: "ISNT_POSSIBLE_TO_UPDATE",
    MSG: "El volante no puede ser actualizado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL003: {
    LABEL: "COULDNT_BE_UPDATED",
    MSG: "El volante no ha podido ser actualizado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL004: {
    LABEL: "MANIFEST_DOESNT_MATCH",
    MSG: "Uno o más volantes tienen un número de manifiesto que no corresponde al de la DAM. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL005: {
    LABEL: "CONSIGNEE_RUC_DOESNT_MATCH",
    MSG: "Uno o más volantes tienen un RUC de consignatario que no corresponde al de la DAM. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL006: {
    LABEL: "NOT_FOUND_IN_MATEO",
    MSG: "Uno o más volantes no pudieron ser encontrados en los registros. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL007: {
    LABEL: "HAS_ALREADY_APPOINTMENT",
    MSG: "Este volante ya tiene una cita programada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL008: {
    LABEL: "VOLANTE_DAM_MISMATCH",
    MSG: "La DAM enviada no corresponde a la del volante en cuestión. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL009: {
    LABEL: "ONE_OR_MORE_VOLANTES_ARE_NOT_PAID",
    MSG: "Uno o más volantes seleccionados no están pagados. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL010: {
    LABEL: "DIFFERENT_WITHDRAWAL_DATE",
    MSG: "Los volantes seleccionados tienen una fecha de retiro diferente. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL011: {
    LABEL: "VOLANTE_TALMA_CONSIGNEE_CREDIT_AUTH_UPDATE_FORBIDDEN",
    MSG: "Estado para la autorización de la línea de crédito del agente importador no puede ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL012: {
    LABEL: "VOLANTE_TALMA_CARGO_AGENT_CREDIT_AUTH_UPDATE_FORBIDDEN",
    MSG: "Estado para la autorización de la línea de crédito del agente de carga no puede ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL013: {
    LABEL: "VOLANTE_TALMA_CONSIGNEE_CREDIT_AUTH_INVALID_STATE_TRANSITION",
    MSG: "La transición del estado de la autorización de la línea de crédito del agente importador es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL014: {
    LABEL: "VOLANTE_TALMA_CARGO_AGENT_CREDIT_AUTH_INVALID_STATE_TRANSITION",
    MSG: "La transición del estado de la autorización de la línea de crédito del agente de carga es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL015: {
    LABEL: "NO_404_NOT_FOUND",
    MSG: "El volante no puede ser actualizado con el día de retiro dado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL016: {
    LABEL: "NO_403_FORBIDDEN",
    MSG: "La transición del valor de la fecha de retiro no es valido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL017: {
    LABEL: "NO_403_FORBIDDEN",
    MSG: "La autorización de RUC facturable no se encuentra aprobada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL018: {
    LABEL: "NO_403_FORBIDDEN",
    MSG: "El usuario ya adjuntó un documento de RUC facturable de terceros. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL019: {
    LABEL: "NO_404_NOT_FOUND",
    MSG: "El volante no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL020: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "La fecha de retiro del volante es inválida. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL021: {
    LABEL: "HTTP_409_CONFLICT",
    MSG: "Se encontró un estado inválido para algún volante. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL022: {
    LABEL: "HTTP_409_CONFLICT",
    MSG: "Se encuentra un estado inválido para algún servicio adicional relacionado con el volante dado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL023: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "No existe ningún servicio asociado al volante dado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL024: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "Uno o más volantes no pueden ser validados para la creación de la cotización. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL025: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El estado de autorización de facturación de terceros no es válido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL026: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El nombre o el RUC de facturación de terceros no es válido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL027: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El número de volante es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL028: {
    LABEL: "VOLANTE_TALMA_CARGO_AGENT_CREDIT_AUTH_UPDATE_FORBIDDEN",
    MSG: "Estado para la autorización de la línea de crédito no puede ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL029: {
    LABEL: "VOLANTE_TALMA_CONSIGNEE_CREDIT_AUTH_INVALID_STATE_TRANSITION",
    MSG: "La transición del estado de la autorización de la línea de crédito es inválida. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL030: {
    LABEL: "VOLANTE_TALMA_CONSIGNEE_CREDIT_AUTH_INVALID_STATE_TRANSITION",
    MSG: "La dam asociada al volante tiene restricción de SENASA. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOL031: {
    LABEL: "VOLANTE_TALMA_CONSIGNEE_CREDIT_AUTH_INVALID_STATE_TRANSITION",
    MSG: "La dam asociada al volante tiene restricción de Mandato Electrónico. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BIR000: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El ruc dado no existe en nuestros registros. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO000: {
    LABEL: "FORBIDDEN_OPERATION",
    MSG: "El usuario no tiene los permisos para realizar esta operación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO001: {
    LABEL: "CONSIGNEE_PAYER_ALLOWED_REQUIRED",
    MSG: "El RUC facturable debe estar aprobado por el consignatario. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO002: {
    LABEL: "QUOTED_PAYMENT_STATUS_REQUIRED",
    MSG: "Uno o más volantes seleccionados no están prefacturados. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO003: {
    LABEL: "ONE_OR_MORE_QUOTATIONS_DOESNT_MATCH_WITH_USER",
    MSG: "Una o más prefacturas no corresponden al agente de aduanas actual. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO004: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "En esta transacción solo está permitido actualizar prefacturas con estado rechazado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO005: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "En esta transacción solo está permitido actualizar prefacturas que han sido recientemente generadas. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO006: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "La transacción dada solo es posible cuando se tiene una sola prefactura. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO007: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "No está permitido actualizar el comentario de la factura electrónica. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO008: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "Se requiere que el agente de carga este autorizado por el usuario administrador. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO009: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El estado de prefactura debe estar en pendiente de validación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO010: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El comentario de la prefactura no puede tener mas de 124 caracteres. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO011: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El comentario de la prefactura no puede tener mas de 124 caracteres. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO012: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "La prefactura no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO013: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "EL estado de la prefactura es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  QUO014: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "ya existe una cotización para este volante. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV000: {
    LABEL: "FORBIDDEN_OPERATION",
    MSG: "El usuario no tiene los permisos para realizar esta operación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV001: {
    LABEL: "INVOICE_STATUS_COULDNT_BE_UPDATED",
    MSG: "La factura no ha podido ser actualizada Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV002: {
    LABEL: "INVALID_PAYMENT_STATUS",
    MSG: "El estado de la factura es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV003: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El banco dado no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV004: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El ruc pagador es inválido para la factura. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV005: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El estado de la factura no puede ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV006: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El banco seleccionado no tiene habilitado el tipo de cuenta. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV007: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "La factura dada no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV008: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El tipo de pago es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV009: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Los números de operación de un mismo banco no pueden ser repetidos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV010: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Es necesario proporcinar un número de operación y un monto para cada uno de los vouchers solicitados. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV011: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Uno de los vouchers proporcionados no corresponden a la factura seleccionada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV012: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El subestado de la factura debe ser PENDIENTE. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV013: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "No se require un comentario de saldo a favor, si el saldo es EXACTO. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV014: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Uno o más de los números de operación ingresados ya han sido utilizados. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV015: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El monto ingresado es insuficiente. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  INV016: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El código de compensación ya ha sido utilizado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP000: {
    LABEL: "CANT_BE_UPDATED",
    MSG: "La cita no ha podido ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP001: {
    LABEL: "CANT_BE_DELETED",
    MSG: "La cita no ha podido ser borrada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP002: {
    LABEL: "CANT_BE_CREATED",
    MSG: "La cita no ha podido ser creada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP003: {
    LABEL: "APPOINTMENT_DOESNT_EXIST",
    MSG: "Esta cita no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP004: {
    LABEL: "APPOINTMENT_CANT_BE_UPDATED",
    MSG: "Esta cita no puede ser actualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP005: {
    LABEL: "APPOINTMENT_TIMESLOT_DIFFERENT_DATE",
    MSG: "Los rangos horarios seleccionados poseen diferentes fechas. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP006: {
    LABEL: "TIMESLOT_WITHOUT_ENOUGH_CAPACITY",
    MSG: "El rango horario seleccionado no tiene suficiente capacidad. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP007: {
    LABEL: "TIMESLOT_NOT_AVAILABLE",
    MSG: "Este rango horario no está disponible. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP008: {
    LABEL: "TIMESLOT_OVERLAP",
    MSG: "Los rangos horarios en este intervalo ya han sido creados. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP009: {
    LABEL: "TIMESLOT_INFO_OUTDATED",
    MSG: "La información de este rango horario está desactualizada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP010: {
    LABEL: "TIMESLOT_OUT_OF_CAPACITY",
    MSG: "La capacidad restante de este rango horario no es suficiente para cubrir lo requerido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP011: {
    LABEL: "INCORRECT_STATUS",
    MSG: "El estado de esta cita es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP012: {
    LABEL: "INCORRECT_HAND_PICKUP_VALUE",
    MSG: "La cita tiene un valor de retiro a mano incorrecto. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP013: {
    LABEL: "INCORRECT_VEHICLES",
    MSG: "La lista de vehículos brindada no puede ser vacía o nula. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP014: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "Alguno de los campos del vehículo no existe o están vacíos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP015: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "No se ha encontrado un conductor con los parámetros dados. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP016: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "Algunos de los parámetros de la lista de vehículos dados se repiten. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP017: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "Operación invalida debido a que se ha superado el peso límite para el retiro a mano. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP018: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "No se puede realizar la búsqueda dado que uno de los despachadores aduaneros no esta asociado a una agencia. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP019: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "Le informamos que el transportista no se encuentra registrado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP020: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Le informamos que solo es posible registrar un máximo de dos transportistas por cada cita. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP021: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "Le informamos que los datos del transportista no están vigente. Agradeceremos contactarse con el equipo de Soporte Talmaclick. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP022: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Agente no válido para la cita. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP023: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "No debería haber vehículos asociados a la cita dada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP024: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "El ticket de control del vehículo debe ser un entero y tener 14 dígitos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  APP025: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Hubo problemas en la transmisión de información a hermes. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  ADS001: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "Hay un servicio adicional no válido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  ADS002: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "La cantidad de servicios adicionales no es válida. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SUN000: {
    LABEL: "SUNAT_CONNECTION_FAILED",
    MSG: "La conexión con el servicio de SUNAT ha fallado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SUN001: {
    LABEL: "SUNAT_SESSION_FAILED",
    MSG: "La conexión con el servicio de SUNAT ha fallado. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SUN002: {
    LABEL: "SUNAT_UNEXPECTED_VALUE_IN_RESPONSE",
    MSG: "El servicio de SUNAT ha presentado fallos y no está disponible en este momento. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SUN003: {
    LABEL: "SUNAT_UNEXPECTED_FORMAT_IN_RESPONSE",
    MSG: "El servicio de SUNAT ha presentado fallos y no está disponible en este momento. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SUN004: {
    LABEL: "SUNAT_NOT_FOUND_VALUE_IN_RESPONSE",
    MSG: "El servicio de SUNAT ha presentado fallos y no está disponible en este momento. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SUN005: {
    LABEL: "SUNAT_NOT_FOUND_VALUE_IN_RESPONSE",
    MSG: "El número de DAM es inválido en SUNAT. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SUN006: {
    LABEL: "SUNAT_NOT_FOUND_VALUE_IN_RESPONSE",
    MSG: "La configuración de SUNAT es inválida. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP000: {
    LABEL: "SESSION_FAILED",
    MSG: "El servicio de facturación no está disponible. Inténtelo de nuevo en un momento. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP001: {
    LABEL: "CONNECTION_FAILED",
    MSG: "El servicio de facturación no está disponible. Inténtelo de nuevo en un momento. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP002: {
    LABEL: "FORBBIDEN_PAYMENT_TYPE_OPERATION",
    MSG: "La Razón Social seleccionada no está habilitada para realizar este tipo de pago. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP003: {
    LABEL: "FORBIDDEN_PAYMENT_TYPE",
    MSG: "La moneda seleccionada no está habilitada para este pago. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP004: {
    LABEL: "FORBIDDEN_PAY_OPERATION",
    MSG: "El usuario no tiene el crédito suficiente para realizar esta operación. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP005: {
    LABEL: "UNEXPECTED_RESPONSE",
    MSG: "El servicio de facturación no está disponible. Inténtelo de nuevo en un momento. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP006: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Se ha podido iniciar sesión con SAP, pero no se ha podido encontrar respuesta a su servicio. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  SAP007: {
    LABEL: "HTTP_401_UNAUTHORIZED",
    MSG: "No pudimos iniciar sesión con SAP, el servicio no funciona bien. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TCI000: {
    LABEL: "HTTP_503_SERVICE_UNAVAILABLE",
    MSG: "No se pudo crear una sesión para conectarse a TCI. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TCI001: {
    LABEL: "HTTP_504_GATEWAY_TIMEOUT",
    MSG: "La conexión TCI falló después de varios intentos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TCI002: {
    LABEL: "REQUEST_FAILED",
    MSG: "El RUC dado no existe en la base de datos de TCI. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TCI003: {
    LABEL: "RESPONSE_FAILED",
    MSG: "A la respuesta de TCI le falta el archivo PDF. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TCI004: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "La conexión SAP-HANA falló después de varios intentos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TCI005: {
    LABEL: "HTTP_500_INTERNAL_SERVER_ERROR",
    MSG: "El archivo PDF no se pudo cargar en S3, verifique la configuración de credenciales. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  TCI006: {
    LABEL: "HTTP_500_INTERNAL_SERVER_ERROR",
    MSG: "No se pudo descargar el archivo desde S3, verifique la configuración de credenciales. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BNK001: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "No hay deuda pendiente de pago. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BNK002: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "No se ha encontrado la deuda en el sistema. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BNK003: {
    LABEL: "HTTP_500_INTERNAL_SERVER_ERROR",
    MSG: "Ha ocurrido un error en la transacción. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BNK004: {
    LABEL: "HTTP_401_UNAUTHORIZED",
    MSG: "No se ha podido procesar el pago. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BNK005: {
    LABEL: "HTTP_401_UNAUTHORIZED",
    MSG: "La deuda tiene restricciones que no permiten realizar la transacción. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BNK006: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "Monto de pago incorrecto. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  BNK007: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "La deuda ya ha sido pagada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  FILE001: {
    LABEL: "HTTP_401_UNAUTHORIZED",
    MSG: "Hay problemas de conectividad para acceder a uno de los servicios usados. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOU001: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El rol del usuario debe de ser backoffice. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR001: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "La agencia no existe o fue eliminada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR002: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "El correo electrónico ya está registrado en nuestra base de datos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR003: {
    LABEL: "HTTP_422_UNPROCESSABLE_ENTITY",
    MSG: "Se encontró un usuario con un estado inválido en nuestra base de datos. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR004: {
    LABEL: "HTTP_403_FORBIDDEN",
    MSG: "El rol de usuario no se puede editar. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR005: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El usuario no tiene perfil. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR006: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El usuario no tiene una empresa relacionada. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR007: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El identificador del usuario es inválido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR008: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El identificador del perfil proporcionado no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR009: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El identificador de uno de los procesos proporcionados no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR010: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "El identificador de la empresa proporcionada no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR011: {
    LABEL: "HTTP_400_BAD_REQUEST",
    MSG: "El perfil seleccionado no está permitido. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  USR012: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "La compañía seleccionada no está permitida. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  NOT001: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "La notificación no existe. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
  VOS001: {
    LABEL: "HTTP_404_NOT_FOUND",
    MSG: "La información de los servicios de uno o más volantes no existen. Agradeceremos contactarse con el equipo de Soporte Talmaclick.",
  },
};

export const TALMA_EXCEPTIONS = {
  GENERIC: {
    INVALID_DATE_FORMAT: {
      CODE: "TAL000",
      MSG: "Formato de fecha inválido.",
    },
    PRECONDITION_FAILED: {
      CODE: "TAL001",
      MSG: "La precondición para esta solicitud ha fallado.",
    },
    INVALID_OPERATION_NUMBER: {
      CODE: "TAL002",
      MSG: "El número de operación dado no es alfanumérico.",
    },
    INVALID_PARAMETER_VALUE: {
      CODE: "TAL003",
      MSG: "El valor de alguno de los parámetros es inválido.",
    },
  },
  DAM: {
    FORBIDDEN_USER: {
      CODE: "DAM000",
      MSG: "El usuario no tiene acceso para realizar esta operación.",
    },
    FORBIDDEN_OPERATION: {
      CODE: "DAM001",
      MSG: "El usuario no tiene los permisos para realizar esta operación.",
    },
    ISNT_POSSIBLE_TO_UPDATE: {
      CODE: "DAM002",
      MSG: "La DAM no ha podido ser actualizada.",
    },
    CANT_BE_UPDATED: {
      CODE: "DAM003",
      MSG: "La DAM no puede ser actualizada.",
    },
    INVALID_DISPATCH_TYPE: {
      CODE: "DAM004",
      MSG: "El tipo de despacho es inválido.",
    },
    DOESNT_EXIST_ADUANA_ERROR: {
      CODE: "DAM005",
      MSG: "La DAM indicada no pudo ser encontrada en los registros de SUNAT.",
    },
    HAS_BLOCKED_LEVANTE: {
      CODE: "DAM006",
      MSG: "La DAM no cuenta con levante autorizado.",
    },
    DELIVERY_DESTINATION_IS_NOT_TALMA: {
      CODE: "DAM007",
      MSG: "El destino de entrega de esta DAM no corresponde a Talma.",
    },
    USER_RUC_DOESNT_MATCH_SUNAT: {
      CODE: "DAM008",
      MSG: "El RUC de la agencia del usuario no corresponde al RUC de la DAM indicada.",
    },
    NOT_PASS_DESPACHO_TYPE_EXCEPTIONAL: {
      CODE: "DAM009",
      MSG: "La información de los bienes de la DAM no corresponde a la de los volantes.",
    },
    NOT_PASS_DESPACHO_TYPE_URGENT: {
      CODE: "DAM010",
      MSG: "La información de los bienes de la DAM no corresponde a la de los volantes.",
    },
    NOT_PASS_DESPACHO_TYPE_ANTICIPATED: {
      CODE: "DAM011",
      MSG: "La información de los bienes de la DAM no corresponde a la de los volantes.",
    },
  },
  VOLANTE: {
    FORBIDDEN_OPERATION: {
      CODE: "VOL000",
      MSG: "El usuario no tiene los permisos para realizar esta operación.",
    },
    THIRD_PARTY_BILLING_AUTHORIZATION_REQUIRED: {
      CODE: "VOL001",
      MSG: "Este RUC Facturable requiere autorización de terceros.",
    },
    ISNT_POSSIBLE_TO_UPDATE: {
      CODE: "VOL002",
      MSG: "El volante no puede ser actualizado.",
    },
    COULDNT_BE_UPDATED: {
      CODE: "VOL003",
      MSG: "El volante no ha podido ser actualizado.",
    },
    MANIFEST_DOESNT_MATCH: {
      CODE: "VOL004",
      MSG: "Uno o más volantes tienen un número de manifiesto que no corresponde al de la DAM.",
    },
    CONSIGNEE_RUC_DOESNT_MATCH: {
      CODE: "VOL005",
      MSG: "Uno o más volantes tienen un RUC de consignatario que no corresponde al de la DAM.",
    },
    NOT_FOUND_IN_MATEO: {
      CODE: "VOL006",
      MSG: "Uno o más volantes no pudieron ser encontrados en los registros.",
    },
    HAS_ALREADY_APPOINTMENT: {
      CODE: "VOL007",
      MSG: "Este volante ya tiene una cita programada.",
    },
    VOLANTE_DAM_MISMATCH: {
      CODE: "VOL008",
      MSG: "La DAM enviada no corresponde a la del volante en cuestión.",
    },
    ONE_OR_MORE_VOLANTES_ARE_NOT_PAID: {
      CODE: "VOL009",
      MSG: "Uno o más volantes seleccionados no están pagados.",
    },
    DIFFERENT_WITHDRAWAL_DATE: {
      CODE: "VOL010",
      MSG: "Los volantes seleccionados no tienen una fecha de retiro diferente.",
    },
  },
  QUOTATION: {
    FORBIDDEN_OPERATION: {
      CODE: "QUO000",
      MSG: "El usuario no tiene los permisos para realizar esta operación.",
    },
    CONSIGNEE_PAYER_ALLOWED_REQUIRED: {
      CODE: "QUO001",
      MSG: "El RUC facturable debe estar aprobado por el consignatario.",
    },
    QUOTED_PAYMENT_STATUS_REQUIRED: {
      CODE: "QUO002",
      MSG: "Uno o más volantes seleccionados no están prefacturados.",
    },
    ONE_OR_MORE_QUOTATIONS_DOESNT_MATCH_WITH_USER: {
      CODE: "QUO003",
      MSG: "Una o más prefacturas no corresponden al agente de aduanas actual.",
    },
  },
  INVOICE: {
    FORBIDDEN_OPERATION: {
      CODE: "INV000",
      MSG: "El usuario no tiene los permisos para realizar esta operación.",
    },
    INVOICE_STATUS_COULDNT_BE_UPDATED: {
      CODE: "INV001",
      MSG: "La factura no ha podido ser actualizada",
    },
    INVALID_PAYMENT_STATUS: {
      CODE: "INV002",
      MSG: "El estado de la factura es inválido.",
    },
  },
  APPOINTMENT: {
    CANT_BE_UPDATED: {
      CODE: "APP000",
      MSG: "La cita no ha podido ser actualizada.",
    },
    CANT_BE_DELETED: {
      CODE: "APP001",
      MSG: "La cita no ha podido ser borrada.",
    },
    CANT_BE_CREATED: {
      CODE: "APP002",
      MSG: "La cita no ha podido ser creada.",
    },
    APPOINTMENT_DOESNT_EXIST: {
      CODE: "APP003",
      MSG: "Esta cita no existe.",
    },
    APPOINTMENT_CANT_BE_UPDATED: {
      CODE: "APP004",
      MSG: "Esta cita no puede ser actualizada.",
    },
    APPOINTMENT_TIMESLOT_DIFFERENT_DATE: {
      CODE: "APP005",
      MSG: "Los rangos horarios seleccionados poseen diferentes fechas.",
    },
    TIMESLOT_WITHOUT_ENOUGH_CAPACITY: {
      CODE: "APP006",
      MSG: "El rango horario seleccionado no tiene suficiente capacidad.",
    },
    TIMESLOT_NOT_AVAILABLE: {
      CODE: "APP007",
      MSG: "Este rango horario no está disponible.",
    },
    TIMESLOT_OVERLAP: {
      CODE: "APP008",
      MSG: "Los rangos horarios en este intervalo ya han sido creados.",
    },
    TIMESLOT_INFO_OUTDATED: {
      CODE: "APP009",
      MSG: "La información de este rango horario está desactualizada.",
    },
    TIMESLOT_OUT_OF_CAPACITY: {
      CODE: "APP010",
      MSG: "La capacidad restante de este rango horario no es suficiente para cubrir lo requerido.",
    },
    INCORRECT_STATUS: {
      CODE: "APP011",
      MSG: "El estado de esta cita es inválido.",
    },
    INCORRECT_HAND_PICKUP_VALUE: {
      CODE: "APP012",
      MSG: "La cita tiene un valor de retiro a mano incorrecto.",
    },
    INCORRECT_VEHICLES: {
      CODE: "APP013",
      MSG: "La lista de vehículos brindada no puede ser vacía o nula.",
    },
  },
};

export const SUNAT_EXCEPTIONS = {
  SUNAT_CONNECTION_FAILED: {
    CODE: "SUN000",
    MSG: "La conexión con el servicio de SUNAT ha fallado.",
  },
  SUNAT_SESSION_FAILED: {
    CODE: "SUN001",
    MSG: "La conexión con el servicio de SUNAT ha fallado.",
  },
  SUNAT_UNEXPECTED_VALUE_IN_RESPONSE: {
    CODE: "SUN002",
    MSG: "El servicio de SUNAT ha presentado fallos y no está disponible en este momento.",
  },
  SUNAT_UNEXPECTED_FORMAT_IN_RESPONSE: {
    CODE: "SUN003",
    MSG: "El servicio de SUNAT ha presentado fallos y no está disponible en este momento.",
  },
  SUNAT_NOT_FOUND_VALUE_IN_RESPONSE: {
    CODE: "SUN004",
    MSG: "El servicio de SUNAT ha presentado fallos y no está disponible en este momento.",
  },
};

export const SAP_EXCEPTIONS = {
  SESSION_FAILED: {
    CODE: "SAP000",
    MSG: "El servicio de facturación no está disponible. Inténtelo de nuevo en un momento.",
  },
  CONNECTION_FAILED: {
    CODE: "SAP001",
    MSG: "El servicio de facturación no está disponible. Inténtelo de nuevo en un momento.",
  },
  FORBBIDEN_PAYMENT_TYPE_OPERATION: {
    CODE: "SAP002",
    MSG: "La Razón Social seleccionada no está habilitada para realizar este tipo de pago.",
  },
  FORBIDDEN_PAYMENT_TYPE: {
    CODE: "SAP003",
    MSG: "La moneda seleccionada no está habilitada para este pago.",
  },
  FORBIDDEN_PAY_OPERATION: {
    CODE: "SAP004",
    MSG: "El usuario no tiene el crédito suficiente para realizar esta operación.",
  },
  UNEXPECTED_RESPONSE: {
    CODE: "SAP005",
    MSG: "El servicio de facturación no está disponible. Inténtelo de nuevo en un momento.",
  },
};

export const TCI_EXCEPTIONS = {
  CONNECTION_FAILED: {
    CODE: "TCI001",
    MSG: "La conexión con el servicio de facturación ha fallado.",
  },
  REQUEST_FAILED: {
    CODE: "TCI002",
    MSG: "La conexión con el servicio de facturación ha fallado.",
  },
  RESPONSE_FAILED: {
    CODE: "TCI003",
    MSG: "La conexión con el servicio de facturación ha fallado.",
  },
  SAP_RESPONSE_FAILED: {
    CODE: "TCI004",
    MSG: "La conexión con el servicio de facturación ha fallado.",
  },
  TCI_S3_UPLOAD_FAILED: {
    CODE: "TCI005",
    MSG: "Ha ocurrido un error al generar la factura.",
  },
};
